var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCotizacionesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2274",
    "data-name": "Trazado 2274",
    className: "cls-1",
    d: "M3.26-8.39h24v24h-24Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2275",
    "data-name": "Trazado 2275",
    className: "cls-2",
    d: "M18.28,3.5H14.23a2.86,2.86,0,0,0-5.46,0h-4a1.58,1.58,0,0,0-.38,0,1.85,1.85,0,0,0-1,.55,2,2,0,0,0-.42.64,2,2,0,0,0-.15.77v14a2,2,0,0,0,.57,1.42,1.85,1.85,0,0,0,1,.55,2.34,2.34,0,0,0,.38,0H18.28a2,2,0,0,0,1.93-2V5.5A2,2,0,0,0,18.28,3.5ZM11.5,3.1a.67.67,0,1,1-.65.68v0a.66.66,0,0,1,.65-.66Zm6.18,16.65H5.32a.81.81,0,0,1-.81-.81V6.12a.81.81,0,0,1,.81-.81H17.68a.81.81,0,0,1,.81.81V18.94A.81.81,0,0,1,17.68,19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.18,13.09a2.27,2.27,0,0,0-.9-.66,9.72,9.72,0,0,0-1.08-.35V9.62a2.2,2.2,0,0,1,.44.12,4.55,4.55,0,0,1,.89.49.82.82,0,0,0,.26.14.45.45,0,0,0,.2,0,.41.41,0,0,0,.33-.19.66.66,0,0,0-.13-1,3.93,3.93,0,0,0-2-.84V7.71A.64.64,0,0,0,12,7.28a.56.56,0,0,0-.43-.16.54.54,0,0,0-.42.16.59.59,0,0,0-.16.43v.73a3,3,0,0,0-1.74.81,2.1,2.1,0,0,0-.67,1.58A1.79,1.79,0,0,0,9,12.07a2.41,2.41,0,0,0,.93.68,10.87,10.87,0,0,0,1.1.36v2.35a4.56,4.56,0,0,1-.62-.13,4.09,4.09,0,0,1-1-.5l-.26-.13a.52.52,0,0,0-.21,0,.43.43,0,0,0-.33.18.76.76,0,0,0-.14.43.57.57,0,0,0,.06.31.55.55,0,0,0,.2.23,3.56,3.56,0,0,0,1.07.57,5.42,5.42,0,0,0,1.27.27v.7a.58.58,0,0,0,.16.43.59.59,0,0,0,.42.17.61.61,0,0,0,.43-.17.62.62,0,0,0,.16-.43v-.72a3,3,0,0,0,1.71-.79,2.11,2.11,0,0,0,.64-1.55A1.8,1.8,0,0,0,14.18,13.09Zm-3.26-1.37a1.61,1.61,0,0,1-.6-.36.78.78,0,0,1-.24-.61,1,1,0,0,1,.42-.86A2.08,2.08,0,0,1,11,9.64v2.11Zm1.75,3.48a2,2,0,0,1-.47.2v-2l.09,0a1.64,1.64,0,0,1,.57.33.68.68,0,0,1,.23.54A1,1,0,0,1,12.67,15.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCotizacionesInactive);
export default __webpack_public_path__ + "static/media/ic-cotizaciones-inactive.56ecf04cc31a4d82efb89e5291acb0d4.svg";
export { ForwardRef as ReactComponent };